export default __webpack_public_path__ + "static/media/sweet.4a5610a8.webp";